module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGCAYAAAARx7TFAAAAV0lEQVQImXWOSwqAMAwFR3Hp8XTvKmA9lLaHsjfpWp6mIIUOhHyYNhnM7AQ2+sQROIC742geJBVg8fxH/aosSWRgb6RQN1RJJODyOnq8TM1r3Tf7Lx/AA7JbD8d5Qm76AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/sy/SANJIAOX.png
// module id = 7Lht
// module chunks = 0